import { useEffect, useState } from "react";
import { Label, makeStyles } from "@fluentui/react-components";
import { IOrphanedWorkspacesInTenantReportSummaryProps } from "./orphaned-workspaces-in-tenant-report-summary.props";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { format } from "date-fns";

const layoutStyles = makeStyles({
    mainWrapper: {
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '1em'
    }
});

export default function OrphanedWorkspacesInTenantReportSummary(props: IOrphanedWorkspacesInTenantReportSummaryProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();

    const [scopeLabel, setScopeLabel] = useState<string>("");

    useEffect(() => {
        if (props.report?.details) {
            const scopes: string[] = [];
            if (props.report.details.includedWorkspaces) {
                scopes.push(t("ppaWorkspaces"));
            }
            if (props.report.details.includedOneDrives) {
                scopes.push(t("ppaOneDrives"));
            }
            setScopeLabel(scopes.join(", "));
        }
    }, [props.report?.details, t]);

    return (
        <div className={styles.mainWrapper}>
            {props.report?.details &&
                <>
                    <div className={styles.section}>
                        <Label>{t("ppaTotalOrphanedWorkspaces")}</Label>
                        <span>{props.report.details.totalOrphanedWorkspaces}</span>
                    </div>
                    <div className={styles.section}>
                        <Label>{t("ppaIncludedScopes")}</Label>
                        <span>{scopeLabel}</span>
                    </div>
                    <div className={styles.section}>
                        <Label>{t("ppaGeneratedOn")}</Label>
                        <span>{format(new Date(props.report.details.generatedOn), "PPp")}</span>
                    </div>
                </>
            }
        </div>
    );
}
